module.exports = __webpack_public_path__ + "static/HeroSelectAll-e9e2f78d01d1c90cc23ca55d352c7aaf.png";